// This function takes HTML content, strips the tags, and returns a short excerpt.
export const createExcerpt = (htmlContent, wordLimit) => {
  if (!htmlContent) {
    return '';
  }

  // Create a temporary div to parse the HTML
  const div = document.createElement('div');
  div.innerHTML = htmlContent;
  
  // Get the text content, which strips all HTML tags
  const text = div.textContent || div.innerText || '';
  
  // Split into words, take the first few, and join them back
  const words = text.split(' ');
  if (words.length > wordLimit) {
    return words.slice(0, wordLimit).join(' ') + '...';
  }
  
  return text;
};